import { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';

import './image-crop-modal.scss';

import { Button } from '../button/Button';
import { Modal } from '../modal/Modal';

export const ImageCropModal = ({ imageSrc, aspect = 1, onCancel, onConfirm }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((_, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  return (
    <Modal
      title="Crop image"
      isOpen
      onClose={onCancel}
      className="image-crop-modal"
      width={520}
      minHeight="auto"
    >
      <div className="image-crop-modal__stage">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
        />
      </div>
      <div className="image-crop-modal__zoom">
        <span>Zoom</span>
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
        />
      </div>
      <div className="image-crop-modal__actions">
        <Button secondary onClick={onCancel}>
          Cancel
        </Button>
        <Button
          onClick={() => croppedAreaPixels && onConfirm(croppedAreaPixels)}
          disabled={!croppedAreaPixels}
        >
          Save crop
        </Button>
      </div>
    </Modal>
  );
};
